module.exports = __webpack_public_path__ + "19bbf257cc959e2018221fcd1b2b7718.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/wine-icon-wt-bg.png
// module id = 1118
// module chunks = 1